<template>
  <div class="text-secondary">
    <div class="mb-2">
      <strong>{{ product.name }} </strong> <br>
    </div>
    <span
      v-if="product.extraJson.hsCode"
      class="badge badge-light border border-bottom-secondary mb-2"
    >
      HS#{{ product.extraJson.hsCode }}
    </span>
    <p>
      {{ product.note }}
    </p>
    <div class="row">
      <div class="col-md-6">
        {{ $t('requestLogisticProduct.miqdar') }} <span class="text-dark">{{ product.count }} {{ product.unit }} </span> <br>
        {{ $t('requestLogisticProduct.qabladrma') }} <span class="text-dark">{{ product.extraJson.packing }}</span> <br>
        - <span v-if="product.extraJson.canBeStacked>0">{{ $t('requestLogisticProduct.ykStstQoyulaBilr') }}</span>
        <span
          v-else
          class="text-danger"
        >{{ $t('requestLogisticProduct.ykStstQoyulaBilmz') }}</span> <br>
      </div>
      <div class="col-md-6">
        {{ $t('requestLogisticProduct.1Ddi') }}
        <span class="text-dark">
          {{ product.extraJson.width }}x{{ product.extraJson.length }}x{{ product.extraJson.height }}
          {{ product.extraJson.sizeUnit }} (ExUxH)
        </span>
        <br>
        {{ $t('requestLogisticProduct.bruttoKisi') }} <span class="text-dark">{{ $t('requestLogisticProduct.kq', {weight: product.extraJson.weight}) }}</span> <br>
        <div
          v-if="product.extraJson.productType === 'temperature'"
          class="text-danger"
        >
          {{ $t('requestLogisticProduct.temperaturRejimliMhsul', {temperature: product.extraJson.temperature, temperatureUnit: product.extraJson.temperatureUnit}) }}
        </div>
        <div
          v-if="product.extraJson.productType === 'dangerous'"
          class="text-danger"
        >
          {{ $t('requestLogisticProduct.thlkliMhsulAdrUn', {adr: product.extraJson.adr, expr: product.extraJson.un || '-'}) }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'RequestLogisticProduct',
  props: {
    product: {}
  }
}
</script>